import { useRef, useState } from "react";
import { faPlay, faPause } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import audioSample from "../assets/audio/audio_sample.mp3";
import readAlongBanner from "../assets/images/read-along.jpg";

const AudioSamplePlayer = () => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleToggleAudio = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnded = () => {
    setIsPlaying(false);
  };

  return (
    <div className="m-0 p-0">
      <div
        className="audio-banner-wrapper position-relative mb-0"
        onClick={handleToggleAudio}
        style={{ cursor: "pointer" }}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === "Enter") handleToggleAudio();
        }}
      >
        <img
          src={readAlongBanner}
          alt="Audio Read-Along Feature"
          className="audio-banner-img w-100 rounded-3 mb-0"
        />
        <button
          className={`btn btn-warning bg-accent position-absolute`}
          style={{ bottom: "20px", right: "20px", backgroundColor: "var(--metro-yellow)" }}
          onClick={(e) => {
            e.stopPropagation();
            handleToggleAudio();
          }}
        >
          {isPlaying ? (
            <>
              <FontAwesomeIcon icon={faPause} className="me-2" />
              Pause audio
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faPlay} className="me-2" />
              Try audio sample
            </>
          )}
        </button>
      </div>
      <p
        className="fw-bold mt-2 mb-0"
        onClick={handleToggleAudio}
        style={{ cursor: "pointer" }}
        role="button"
        tabIndex={0}
      >
        <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} className="me-2" />
        {isPlaying ? "Playing..." : "Listen to Sample Audio"}
      </p>
      <audio
        ref={audioRef}
        src={audioSample}
        preload="auto"
        onEnded={handleAudioEnded}
        className="d-none"
      />
    </div>
  );
};

export default AudioSamplePlayer;
